'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { PerformanceLabSection } from './types';
import styles from './CategorySidebar.module.css';

interface CategorySidebarProps {
  sections: PerformanceLabSection[];
  activeCategory?: string;
  onCategoryChange?: (categoryId: string) => void;
  topOffset: number;
  mobileTopOffset: number;
  sidebarRef?: React.MutableRefObject<HTMLElement | null>;
  categoryRefs?: React.MutableRefObject<Record<string, HTMLElement | null>>;
}

const CategorySidebar: React.FC<CategorySidebarProps> = ({
  sections,
  activeCategory,
  onCategoryChange,
  topOffset,
  mobileTopOffset,
  sidebarRef,
  categoryRefs,
}) => {
  const t = useTranslations('diagnostics');
  return (
    <aside
      className={`${styles.sidebar} u-hide-scrollbar`}
      style={
        {
          ['--pl-top-offset']: `${topOffset}px`,
          ['--pl-mobile-top-offset']: `${mobileTopOffset}px`,
        } as React.CSSProperties
      }
      data-category-sidebar
      ref={(el) => {
        if (sidebarRef) {
          sidebarRef.current = el;
        }
      }}
    >
      <div className={styles.sidebarHeader}>
        <h2 className={styles.sidebarTitle}>{t('sidebar.title')}</h2>
        <p className={styles.sidebarDescription}>
          {t('sidebar.description')} <br />
        </p>
        <p className={styles.sidebarDescription}>Bengaluru, India.</p>
      </div>
      <hr className={styles.separator} />
      <nav className={styles.categoryNav}>
        {sections.map((section) => (
          <button
            key={section.id}
            className={`${styles.categoryItem} gtm`}
            data-buttontype="performance_lab_buy_sidebar_nav"
            data-active={activeCategory === section.id ? 'true' : undefined}
            onClick={() => onCategoryChange?.(section.id)}
            data-category={section.id}
            data-section-label={t(section.sidebarLabel)}
            ref={(el) => {
              if (categoryRefs) {
                categoryRefs.current[section.id] = el;
              }
            }}
          >
            <span
              className={styles.blueDot}
              data-active={activeCategory === section.id ? 'true' : undefined}
            />
            <span
              className={styles.categoryText}
              data-active={activeCategory === section.id ? 'true' : undefined}
            >
              {t(section.sidebarLabel)}
            </span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default CategorySidebar;
